<template>
  <div>
    <div class="top">
      <el-button type="primary" @click="back">返回</el-button>
    </div>
    <div class="title">工单详情</div>
    <table>
      <tr>
        <th>服务名称</th>
        <th style="color:#666666">{{tableList.jj}}</th>
        <th>服务内容</th>
        <th style="color:#666666">{{tableList.jj}}</th>
        <th>客户姓名</th>
        <th style="color:#666666">{{tableList.dd}}</th>
        <th>联系地址</th>
        <th style="color:#666666">{{tableList.ff}}</th>
      </tr>
    </table>
    <div class="body">
        <div class="border"></div>
       <div class="list">
        <p style="width:60px;color:#333333">11-15 11:15</p>
        <p style="font-size: 32px;color:#333333">①</p>
        <p style="color:#333333">
          下单:
          <span style="color:#666666">管理员</span>
        </p>
        <p style="color:#333333">
          派单长：
          <span style="color:#666666">40分钟</span>
        </p>
      </div>
       <div class="list" >
        <p style="width:60px">11-15 11:30</p>
        <p style="font-size: 32px;">②</p>
        <p>
          接单:
          <span>{{tableList.hh}}</span>
        </p>
      </div>
       <div  class="list">
        <p style="width:60px">11-15 11:40</p>
        <p style="font-size: 32px;">③</p>
        <p>
          签到:
          <span>{{tableList.hh}}</span>
        </p>
        <p>
          签到地址：
          <span>{{tableList.ff}}</span>
        </p>
      </div>
       <div  class="list">
        <p style="width:60px">11-15 11:41</p>
        <p style="font-size: 32px;">④</p>
        <p>
          服务内容:
          <span>{{tableList.jj}}</span>
        </p>
        <p>
          异常情况：
          <span>无异常</span>
        </p>
      </div>
       <div  class="list">
        <p style="width:60px">11-15 11:50</p>
        <p style="font-size: 32px;">⑤</p>
        <p>
          签退:
          <span>{{tableList.hh}}</span>
        </p>
        <p>
          超长时长
          <span>0分钟</span>
        </p>
         <p>
          签退内容
          <span>拍照</span>
        </p>
      </div>
      <div  class="list">
        <p style="width:60px">11-15 11:52</p>
        <p style="font-size: 32px;">⑥</p>
        <p>
          客户确认:
          <span>{{tableList.dd}}</span>
        </p>
        <p>
          签到地址
          <span>{{tableList.ff}}</span>
        </p>
         <p>
          签退内容
          <span>拍照</span>
        </p>
      </div>
      <div  class="list">
        <p style="width:60px">11-15 11:53</p>
        <p style="font-size: 32px;">⑦</p>
        <p>
          工单完成:
          <span>{{tableList.dd}}</span>
        </p>
        <p>
          超长时间：
          <span>0分钟</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableList: {
        jj: this.$route.query.row.jj,
        dd: this.$route.query.row.dd,
        ff: this.$route.query.row.ff,
        hh:this.$route.query.row.hh,
      }
    };
  },
  methods: {
    back() {
      this.$router.push({ path: "/ServiceWorkOrder" });
    }
  },
  mounted() {
    console.log(this.$route.query);
  }
};
</script>
<style lang="scss" scoped>
.top {
  background: #f2f2f2;
  padding: 8px 8px;
}
.title {
  text-align: center;
  font-size: 26px;
  margin: 10px 0;
}
table {
  border-collapse: collapse;
  width: 100%;
  height: 60px;
}

table,
td,
th {
  border: 1px solid #dcdcdc;
}
.body {
    position: relative;
  p {
    font-size: 16px;
    margin-right: 20px;
  }
  .list{
      display: flex;
      align-items: center;
      margin-top: 20px;
      margin-right: 10px;
      p{
          color: #cccccc;
          span{
              display: inline-block;
              color: #333333;
              margin-left: 10px;
          }
      }
  }
  .border{
        position: absolute;
        width: 1px;
        height: 30px;
        background: #cccccc;
        top: 10px;
    }
}
</style>